export default {
    HOST: "http://localhost:6966"
    , MY_AMIIBO_PAGE: "/my_amiibo"
    , LANDING_PAGE: "/"
    , USER_SINGLES_MATCHES_PAGE: "/my_matches"
    , FAQ: "/faq"
    , ACCOUNT_INFO: "/account_info"
    , LEADERBOARD: "/leaderboard"
    , TIER_LIST: "/tier_list"
}